// For Translating Boost App
var translationMapFR = {
  'soort gebouw': 'Type de bâtiment',
  'oppervlakte (m²)': 'Superficie (m²)',
  'prijs (€)': 'Prix (€)',
  'prijs':'Prix',
  'bouwwijze': 'Méthode de construction',
  'type dak': 'Type de toit',
  'bouwvergunning': 'Permis de construire',
  'breedte': 'Largeur',
  'hoogte': 'Hauteur',
  'lengte': 'Longueur',
  'bijgebouw': 'Annexe',
  'carport': 'Carport',
  'chalet': 'Chalet',
  'garage': 'Garage',
  'home fitness': 'Salle de fitness à domicile',
  'home office': 'Bureau à domicile',
  'kangoeroewoning': 'Maison kangourou',
  'man cave': 'Cave à homme',
  'overkapping': 'Couverture',
  'paardenstal': 'Écurie',
  'pergola': 'Pergola',
  'poolhouse': 'Poolhouse',
  'schuur': 'Grange',
  'stal': 'Étable',
  'yoga paviljoen': 'Pavillon de yoga',
  'aanbouw': 'Extension',
  'vrijstaand': 'Indépendant',
  'kapschuur dak': 'Toit de grange',
  'plat dak': 'Toit plat',
  'pyramidedak':'Toit en pyramide',
  'schilddak': 'Toit en croupe',
  'zadeldak': 'Toit à deux versants',
  'yes': 'Oui'
};
var translationMapEN = {
  'soort gebouw': 'Type of building',
  'oppervlakte (m²)': 'Area (m²)',
  'prijs (€)': 'Price (€)',
  'prijs':'Price',
  'bouwwijze': 'Construction method',
  'type dak': 'Type of roof',
  'bouwvergunning': 'Building permit',
  'breedte': 'Width',
  'hoogte': 'Height',
  'lengte': 'Length',
  'bijgebouw': 'Annex',
  'carport': 'Carport',
  'chalet': 'Chalet',
  'garage': 'Garage',
  'home fitness': 'Home fitness',
  'home office': 'Home office',
  'kangoeroewoning': 'Kangaroo house',
  'man cave': 'Man cave',
  'overkapping': 'Covering',
  'paardenstal': 'Stable',
  'pergola': 'Pergola',
  'poolhouse': 'Poolhouse',
  'schuur': 'Barn',
  'stal': 'Stables',
  'yoga paviljoen': 'Yoga pavilion',
  'aanbouw': 'Extension',
  'vrijstaand': 'Detached',
  'kapschuur dak': 'Shed roof',
  'plat dak': 'Flat roof',
  'schilddak': 'Hipped roof',
  'zadeldak': 'Gabled roof',
  'pyramidedak':'Pyramid roof',
  'yes': 'Yes'
};

function getTranslationFR(key, original){
  if(translationMapFR && translationMapFR.hasOwnProperty(key) && translationMapFR[key]){
    return translationMapFR[key];
  }
  return original;
}

function getTranslationEN(key, original){
  if(translationMapEN && translationMapEN.hasOwnProperty(key) && translationMapEN[key]){
    return translationMapEN[key];
  }
  return original;
}

window.addEventListener("load", documentLoadedHandler);
function documentLoadedHandler(){
  setTimeout(function(){
     performCustomTranslations();
  },3000);
}

function filterButtonClickHandler(){
 setTimeout(performCustomTranslations, 500);
}

function performCustomTranslations(){
  //clear buttons listener
  var filterButtons = document.querySelectorAll(".boost-sd__filter-option-item-button,.boost-sd__filter-option-label,.boost-sd__filter-tree-vertical-toolbar-middle,.boost-sd__filter-option-itemwrapper,.boost-sd__filter-option-range-slider-slider,.boost-sd__refine-by-vertical-refine-by-clear,.boost-sd__filter-tree-vertical-refine-by-clear,.type-dak-txt");
  var i = 0;
  var len = 0;
  if(filterButtons && filterButtons.length > 0){
    len = filterButtons.length;
    for(i;i<len;i++){
     filterButtons[i].addEventListener("click", filterButtonClickHandler); 
    }
  }
  if(Shopify.locale == "fr" || Shopify.locale == "en"){
    translateFilterTexts(Shopify.locale,"boost-sd__filter-option-title");
    translateFilterTexts(Shopify.locale,"boost-sd__filter-option-item-label");
    translateSelectedRefineOptions(Shopify.locale);
    translateFilterTexts(Shopify.locale,"type-dak-txt");
    translateFilterTexts(Shopify.locale,"boost-sd__filter-tree-vertical-toolbar-middle");
  }
}
// Translate Filter texts 
function translateFilterTexts(locale,elementSelector){
   var elements = document.getElementsByClassName(elementSelector);
   var i = 0;
   var len = 0;
   var currentElement;
   var currentElementText;
   
   if(elements && elements.length > 0){
      len = elements.length;     
     for(i;i<len;i++){
        currentElement = elements[i];
        currentElementText = currentElement.innerText.trim().toLowerCase();
        currentElementText = currentElementText.replace(/\n/g, ' ');
      
        currentElement.innerText = locale == 'fr' ? getTranslationFR(currentElementText, currentElement.innerText) : getTranslationEN(currentElementText, currentElement.innerText);
     }    
   }
}

// Translate Selected options
function translateSelectedRefineOptions(locale) {
  var elements = document.getElementsByClassName("boost-sd__filter-tree-vertical-refine-by-item");
  var i = 0;
  var len = 0;
  var currentElement;
  var currentElementLabelText;
  var currentElementValueText;

  if (elements && elements.length > 0) {
    len = elements.length;

    for (i; i < len; i++) {
      currentElement = elements[i];
      // Check if innerText has the expected format
      if (currentElement.innerText.includes(": ")) {
        currentElementLabelText = currentElement.innerText.split(": ")[0].trim().toLowerCase();
        currentElementValueText = currentElement.innerText.split(": ")[1].trim().toLowerCase();
        currentElement.innerHTML = locale == 'fr' ?
          '<span class="boost-sd__filter-tree-vertical-refine-by-type"><span class="boost-sd__filter-tree-vertical-refine-by-option">' + getTranslationFR(currentElementLabelText, currentElement.innerText.split(": ")[0]) + ": </span>" +
          '<span class="boost-sd__filter-tree-vertical-refine-by-value">' + getTranslationFR(currentElementValueText, currentElement.innerText.split(": ")[1]) + "</span></span>" +'<svg class="boost-sd__filter-tree-vertical-refine-by-clear" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg>'  :
          '<span class="boost-sd__filter-tree-vertical-refine-by-type"><span class="boost-sd__filter-tree-vertical-refine-by-option">' + getTranslationEN(currentElementLabelText, currentElement.innerText.split(": ")[0]) + ": </span>" +
          '<span class="boost-sd__filter-tree-vertical-refine-by-value">' + getTranslationEN(currentElementValueText, currentElement.innerText.split(": ")[1]) + "</span></span>" +
          '<svg class="boost-sd__filter-tree-vertical-refine-by-clear" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z" fill="#3D4246"></path></svg>';
    
          }
    }
  }
}

